import { scrollOptions } from "src/common/utilities/Utilities";
import { IResizableImage } from "src/components/moray/ResizeableImage";
import localeService from "src/dataServices/LocaleService";
import HighlightBanner, { IHighlightBanner } from '../shared/HighlightBanner';
import HighlightBannerCarousel from "../shared/HighlightBannerCarousel";
import useD365CopilotOfferUpdate from './useD365CopilotOfferUpdate';

interface ID365TopBanner {
  offersElement: HTMLDivElement | null;
}

const D365TopBanner = ({ offersElement }: ID365TopBanner) => {
  const { isD365CopilotOfferAvailable } = useD365CopilotOfferUpdate();

  const resizableImageProps: IResizableImage[] = [
    {
      root: `${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/D365`,
      imageSrc: `${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/D365/D365-HighlightBanner1-540.jpg`,
      imageClassName: 'img-fill-container card-img',
      imageAlt: '',
      ariaHidden: true,
      fileSize1920: 'D365-HighlightBanner1-1920.jpg',
      fileSize1400: 'D365-HighlightBanner1-1400.jpg',
      fileSize1084: 'D365-HighlightBanner1-1084.jpg',
      fileSize860: 'D365-HighlightBanner1-860.jpg',
      fileSize540: 'D365-HighlightBanner1-540.jpg',
      fileSize360: 'D365-HighlightBanner1-360.jpg'
    },
    {
      root: `${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/D365`,
      imageSrc: `${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/D365/D365-HighlightBanner2-540.jpg`,
      imageClassName: 'img-fill-container card-img',
      imageAlt: '',
      ariaHidden: true,
      fileSize1920: 'D365-HighlightBanner2-1920.jpg',
      fileSize1400: 'D365-HighlightBanner2-1400.jpg',
      fileSize1084: 'D365-HighlightBanner2-1084.jpg',
      fileSize860: 'D365-HighlightBanner2-860.jpg',
      fileSize540: 'D365-HighlightBanner2-540.jpg',
      fileSize360: 'D365-HighlightBanner2-360.jpg'
    },
    {
      root: `${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/D365`,
      imageSrc: `${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/D365/D365-HighlightBanner3.jpg`,
      imageClassName: 'card-img w-100',
      imageAlt: localeService.getText('Dynamic365V2', 'HighlightBannerImgAlt3')
    },
    {
      root: `${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/D365`,
      imageSrc: `${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/D365/D365-HighlightBanner4.jpg`,
      imageClassName: 'card-img w-100',
      imageAlt: '',
      ariaHidden: true
    }
  ];

  const children: React.ReactElement<IHighlightBanner>[] = [
    <HighlightBanner
      titleText={localeService.getText('Dynamic365V2', 'HighlightBannerTitle4')}
      descriptionText={localeService.getText('Dynamic365V2', 'HighlightBannerDescription4')}
      additionalDescription={localeService.getText('Dynamic365V2', 'HighlightBannerAdditionalDescription4')}
      buttonText={localeService.getText('Dynamic365V2', 'HighlightBannerButton4')}
      buttonOnClick={() => {
        window.open(localeService.getText('Dynamic365V2', 'HighlightBannerButton4Link'), '_blank');
      }}
      secondButtonText={localeService.getText('Dynamic365V2', 'HighlightBannerSecondButton4')}
      secondButtonOnClick={() => {
        window.open(localeService.getText('Dynamic365V2', 'HighlightBannerButton4SecondLink'), '_blank');
      }}
      buttonLink={localeService.getText('Dynamic365V2', 'HighlightBannerButton4Link')}
      buttonAriaLabel={localeService.getText('Dynamic365V2', 'HighlightBannerButton4AriaLabel')}
      secondButtonLink={localeService.getText('Dynamic365V2', 'HighlightBannerButton4SecondLink')}
      secondButtonAriaLabel={localeService.getText('Dynamic365V2', 'HighlightBannerSecondButton4AriaLabel')}
      resizableImageProps={resizableImageProps[3]}
    />,
    <HighlightBanner
      titleText={localeService.getText('Dynamic365V2', 'HighlightBannerTitle3')}
      descriptionText={localeService.getText('Dynamic365V2', 'HighlightBannerDescription3')}
      buttonText={localeService.getText('Dynamic365V2', 'HighlightBannerButton3')}
      buttonOnClick={() => {
        window.open(localeService.getText('Dynamic365V2', 'HighlightBannerButton3Link'), '_blank');
      }}
      buttonLink={localeService.getText('Dynamic365V2', 'HighlightBannerButton3Link')}
      buttonAriaLabel={localeService.getText('Dynamic365V2', 'HighlightBannerButton3AriaLabel')}
      resizableImageProps={resizableImageProps[2]}
    />,
    <HighlightBanner
      titleText={localeService.getText('Dynamic365V2', 'HighlightBannerTitle1')}
      descriptionText={localeService.getText('Dynamic365V2', 'HighlightBannerDescription1')}
      buttonText={localeService.getText('Dynamic365V2', 'HighlightBannerButton1')}
      buttonOnClick={() => {
        if (offersElement !== null) {
          offersElement.scrollIntoView(scrollOptions);
        }
      }}
      buttonAriaLabel={localeService.getText('Dynamic365V2', 'HighlightBannerButton1AriaLabel')}
      resizableImageProps={resizableImageProps[0]}
    />
  ];

  if (!isD365CopilotOfferAvailable) {
    children.shift(); // Remove the first child if offer is not available
  }

  return <HighlightBannerCarousel>{children}</HighlightBannerCarousel>;
};

export default D365TopBanner;
